import React from 'react';
import { PortableText } from '@portabletext/react';
import { PortableTextBlock } from '@portabletext/types';
import RichTextComponents from './RichTextComponents';
import styles from './RichText.module.scss';

interface RichTextProps {
  value: PortableTextBlock[];
  className?: string;
}

const HIHRichText: React.FC<RichTextProps> = ({ value, className }) => {
  return (
    <div className={[styles.richText, className].filter(Boolean).join(' ')}>
      <PortableText value={value} components={RichTextComponents} />
    </div>
  );
};

export default HIHRichText;
